/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QueryDto } from '../../models/query-dto';

export interface AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Params {
  sessionId: string;
  interactionId: string;
}

export function aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain(http: HttpClient, rootUrl: string, params: AiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<QueryDto>> {
  const rb = new RequestBuilder(rootUrl, aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain.PATH, 'post');
  if (params) {
    rb.path('sessionId', params.sessionId, {});
    rb.path('interactionId', params.interactionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QueryDto>;
    })
  );
}

aiSessionsSessionIdInteractionsInteractionIdAcceptPost$Plain.PATH = '/ai/sessions/{sessionId}/interactions/{interactionId}/accept';
